<template>
  <main>
    <h1 class="text-green">{{this.dat.Title}}</h1>
    <h3>Descarga aquí tu {{this.dat.Title}} de una forma segura y rápida.</h3>
    <form>
      <FormItem
        v-for="input in this.dat.Inputs"
        :key="input.Id"
        :id="input.Id"
        :label="input.Label"
        v-model="input.Value"
        :type="input.Type"
      ></FormItem>
      <div class="form-footer">   
        <div class="center"> 
          <div v-if="emptyData" style="
              position: fixed;
              width: 100% !important;
              height: 6em !important;
              margin: auto;
              background-color: #ffffffa3;
          "></div>
          <vue-recaptcha ref="recaptcha" v-if="this.$useCaptcha" :loadRecaptchaScript="true" :sitekey="this.$keyCaptcha" v-on:verify="captchaVerify"></vue-recaptcha>   
        </div>
        <Btn
          action="submit"
          type="green"
          :disabled="submitDisabled || emptyData"
          @click.prevent="submit"
        >{{sumbitText}}</Btn>
      </div>
    </form>
    <Spinner v-if="loading" type="modern"></Spinner>
  </main>
</template>

<script>
import api from "../api/reports";
import Btn from "../components/UIElements/Btn";
import Spinner from "../components/UIElements/Spinner";
import FormItem from "../components/UIElements/Form/FormItem";
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: "FormReport",
  components: { Btn, FormItem, Spinner, VueRecaptcha },
  data() {
    return {
      emptyData: true,
      loading: false,
      dat: {
        Title: "Reporte",
        Inputs: [],
        FileName: ""
      },
      submitDisabled: true,
      sumbitText: "Descargar",
      token: {},
      id: ""
    };
  },
  async created() {
    await this.getData(this.$route.params.id);
  },
  methods: {
    captchaVerify (response){
      this.submitDisabled = false;
      this.token = response;
    },
    async getData(id) {
      this.loading = true;
      this.id = id;

      try {
        var resp = await api.get(this, id);
        if (!resp.error) {
          this.dat = resp;
          this.emptyData = false;
          if (!this.$useCaptcha){
            this.submitDisabled = false;
          }
        }
      } catch (e) {
        this.$alert("Ocurrió un error al intentar consultar tu archivo");
      } finally {
        this.loading = false;
      }
      return true;
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(reportName, byte) {
      var blob = new Blob([byte], { type: "application/pdf" });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = reportName;
      link.click();
    },
    async submit() {
      this.loading = true;
      //this.token = await this.$recaptcha("download");

      var dat = {
        id: this.id,
        recaptchaToken: this.token,
        data: this.dat.Inputs
      };
      try {
        var file = await api.download(this, dat);
        if (!file.error) {
          if (file.Reporte) {
            var pdf = this.base64ToArrayBuffer(file.Reporte);
            this.saveByteArray(this.dat.FileName, pdf);            
            // this.$router.go(); -- eJemplo de reload de la vista con el router
          } else {
            this.$alert(
              "Ocurrió un error al intentar descargar tu " + this.dat.Title
            );
          }
        }
      } catch (e) {
        this.$alert(
          "Ocurrió un error al intentar descargar tu " + this.dat.Title
        );
      } finally {
        this.loading = false;
        this.$refs.recaptcha.reset();
        this.submitDisabled = true;
      }
    }
  }
};
</script>

<style>

form {
  margin: 1em auto;
}

form .form-footer {
  width: 100%;
  box-sizing: border-box;
  float: left;
  margin-bottom: 10px;
}

form .form-item {
  width: 100%;
  box-sizing: border-box;
  float: left;
  margin: 1em auto;
}

form label {
  display: block;
  padding: 0.5em 0;
  color: #777;
}

form input[type=text], form input[type=number], form input[type=email], form textarea {
  outline: none;
  text-align: center;
  border-width: 0px 0px 1px;
  border-top-style: initial;
  border-right-style: initial;
  border-bottom-style: solid;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-bottom-color: rgb(204, 204, 204);
  border-left-color: initial;
  border-image: initial;
  background-color: white;
  font: inherit;
  display: block;
  width: 20em;
  box-sizing: border-box;
  color: #777;
  font-weight: 600;
  margin: auto;
}

.form-footer {
  margin-top: 1.5em;
}

@media screen and (max-width: 320px) {
  form input[type=text], form input[type=number], form input[type=email] {
    width: 18em;
  }
}
</style>
